import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { postData, setToken } from '../../services/request';
import "./ShoppingCart.css";

function ShoppingCart() {

  const [isVisible, setIsVisible] = useState(false);
  const [list, setList] = useState([]);

  const handleClick = () => {
    isVisible ? setIsVisible(false) : setIsVisible(true);
    setList(JSON.parse(localStorage.getItem('cart')));
  };

  const deleteItem = (ref) => {
    const newList = list.filter((e) => e.ref !== ref);
    setList(newList);
    localStorage.setItem('cart', JSON.stringify(newList));
  };

  // função do useEffect implementada no handleClick que abre o carrinho
  // useEffect(() => {
  //   setList(JSON.parse(localStorage.getItem('cart')));
  // }, []);

  const cleanCart = () => {
    localStorage.removeItem('cart');
    setList([]);
  };

  const createOrder = async () => {
    const data = JSON.parse(sessionStorage.getItem('login'))
    const token = data.token;
    const user = data.user;
    setToken(token);
    const value = list.reduce((arr, curr) => { return arr + curr.cashTotal}, 0);
    const payload = {
      "customerId": user._id,
      "customerName": user.name,
      "products": list,
      value,
    };
    const order = await postData('/orders', payload);
    cleanCart();
    return order;
  };

  const redirectToWhatsapp = async () => {
    const order = await createOrder();
    const data = JSON.parse(sessionStorage.getItem('login'))
    const user = data.user;
    const text = `Olá, me chamo ${user.name} e gostaria de finalizar o meu pedido com ID: ${order._id} e valor total de R$ ${order._value.toFixed(2).replace('.',',')}`;
    window.open(`https://wa.me/5587996420559/?text=${text}`, '_blank');
  };

  const isLogged = () => {
    const data = JSON.parse(sessionStorage.getItem('login'))
    return data;
  };

  return (
    isVisible ? (
      <main className="shop-cart">
        <section className="cart-container">
          <h2>Meu carrinho</h2>
          {
            list && list.length > 0 ? (
              <div>
                {
                  list.map((e, index) =>
                    <article className="cart-item" key={`${e.ref}`}>
                      <img
                        src={e.thumbs}
                        alt={`product-id-${e.ref}`}
                        className="product-card-image"
                      />
                      <div className="cart-item-data">
                        <h4 className="cart-title">{e.name}</h4>
                        <p>referência do produto: {e.ref}</p>
                        <p>tamanhos selecionados:</p>
                        {
                          Object.entries(e.size).map((s) => <p key={`${e.ref}-${s[0]}`}>{`${s[0]}: ${s[1]}`}</p>)
                        }
                        <p>{`preço unitário: R$ ${e.cashPrice}`.replace('.', ',')}</p>
                        <p>{`total à vista: R$ ${e.cashTotal}`.replace('.', ',')}</p>
                        <p>{`4x de R$ ${e.parcel}`.replace('.', ',')}</p>
                        <div>
                          <Link to={`/products/${e.ref}`}>
                            <button className="cart-item-control">
                              <img src="https://i.postimg.cc/7hFFxfvM/pen.png" alt="edit.png" />
                            </button>
                          </Link>
                          <button
                            type="button"
                            className="cart-item-control"
                            onClick={() => deleteItem(e.ref)}
                          >
                            <img src="https://i.postimg.cc/kGSTnsvD/trash.png" alt="excluir.png" />
                          </button>
                        </div>
                      </div>
                    </article>)
                }
                <p>
                  Total do carrinho: R$ {
                    list.reduce((acc, curr) => {
                      return acc + curr.cashTotal;
                    }, 0).toFixed(2).replace('.', ',')
                  }
                </p>
                {
                  isLogged() ? (
                    <div>
                      <button type="button" onClick={redirectToWhatsapp}>Confirmar pedido</button>
                      <button type="button" onClick={cleanCart}>Cancelar pedido</button>
                      <p>Atualmente os pedidos estão sendo finalizados através de nosso whasapp, ao confirmar, você será redirecionado para nosso canal de atendimento.</p>
                    </div>
                  ) : (
                    <Link to="/login">Você precisa fazer login para continuar. Click aqui</Link>
                  )
                }
                
              </div>
            ) : <p>Você ainda não adicionou itens ao seu carrinho</p>
          }
        </section>
        <button type="button" className="btn-close" onClick={handleClick}>X</button>
      </main>
    ) : (
      <button className="cart-btn" onClick={handleClick}>
        <img src="https://i.postimg.cc/wTLtxC6P/wired-lineal-146-basket-trolley-shopping-card.gif" alt="cart-icon" />
      </button>
    )
  )
};

export default ShoppingCart;
